import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map, switchMap, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { environment } from 'src/environments/environment';
import { ICreateAccount } from 'src/app/shared/account/create-account.helper';
import { AccountDataFormService } from 'src/app/common-logic/account-data-form/account-data-form.service';
import { HttpUtilsService } from '../../../shared/http-utils/http-utils.service';
import { ItemResponseWrapper } from 'src/app/shared/http.types';
import { AccountsService } from '../../../accounts/accounts.service';

@Injectable({ providedIn: 'root' })
export class PublisherDataFormService extends AccountDataFormService {
  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private accountService: AccountsService
  ) {
    super();
  }

  public getData(accountId: string): Observable<ItemResponseWrapper<any>> {
    return this.http.get<ItemResponseWrapper<any>>(`${environment.backendBaseUrl}/shops/${accountId}`)
      .pipe(
        map(this.httpUtils.entityWrapperResponseMapper),
        switchMap(value => {
          if (value?.logoId) {
            return this.getLogo(value?.logoId)
              .pipe(
                map(logo => ({ ...value, logo }))
              );
          }

          return of(value);
        })
      );
  }

  public updateData(value: ICreateAccount, accountId: string): Observable<void> {
    const { logo, ...otherValues } = value;
    const updateShopData = (logoId: string = '') => this.updateShopData({ ...otherValues, logoId }, accountId);

    if (logo?.file) {
      return this.uploadLogo(logo.file, logo?.params?.name)
        .pipe(
          switchMap(({ data: logoId }) => updateShopData(logoId))
        );
    }

    return updateShopData();
  }

  public deleteLogo(shopId: string): Observable<ItemResponseWrapper<string>> {
    return this.http.delete<ItemResponseWrapper<string>>(environment.backendBaseUrl + `/shops/${shopId}/logo`);
  }

  private updateShopData(value: ICreateAccount, accountId: string): Observable<void> {
    return this.http.put<void>(`${environment.backendBaseUrl}/shops/${accountId}`, value)
      .pipe(
        tap(() => this.accountService.fetchPublishers()),
      )
  }

  private getLogo(logoId: string): Observable<Blob> {
    return this.http.get(`${environment.backendBaseUrl}/shops/logo/get/${logoId}`, {
      responseType: 'blob'
    });
  }

  private uploadLogo(logo: File, name: string): Observable<ItemResponseWrapper<string>> {
    const formData: FormData = new FormData();
    formData.append('file', logo, name);

    return this.http.post<ItemResponseWrapper<string>>(environment.backendBaseUrl + '/shops/logo/upload', formData);
  }
}
